import { render, staticRenderFns } from "./LabelDropdownItem.vue?vue&type=template&id=83d0abbc&scoped=true&"
import script from "./LabelDropdownItem.vue?vue&type=script&lang=js&"
export * from "./LabelDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./LabelDropdownItem.vue?vue&type=style&index=0&id=83d0abbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d0abbc",
  null
  
)

export default component.exports